module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lemons@3x_eaeebd.jpg";